import { Divider, SmallTitle } from '@indigo-ag/component-module';
import { CreditApprovalExceptionsAndConditionals } from 'features/brazil-grower/components/DecisionSheet/CreditApproval/CreditApprovalExceptionsAndConditionals';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import i18next from 'i18next';
import React, { useContext } from 'react';
import { LoadingIndicator } from 'shared';

import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 2rem 0;
`;

const ExceptionsAndConditionalsWrapper = styled.div`
  display: block;
  width: 100%;
  min-height: fit-content;
`;

const ConditionalsAndExceptions = () => {
  const { creditApprovalDataQuery, importedExceptions } = useContext(FinanceProcessContext);

  if (creditApprovalDataQuery?.loading) {
    return <LoadingIndicator />;
  }

  const round = creditApprovalDataQuery?.data?.creditApprovalData?.round;

  return (
    <Wrapper>
      <SmallTitle>{i18next.t('creditCollateralExceptions-label')}</SmallTitle>
      <ExceptionsAndConditionalsWrapper>
        <CreditApprovalExceptionsAndConditionals
          round={round ? { ...round, creditConditionals: [] } : undefined}
          exceptionsAlreadyAdded={importedExceptions}
        />
      </ExceptionsAndConditionalsWrapper>
      <Divider style={{ marginTop: '0.5rem' }} />
    </Wrapper>
  );
};

export default ConditionalsAndExceptions;
